import {
  Component,
  ChangeDetectionStrategy,
  HostBinding,
  AfterViewInit,
  ChangeDetectorRef,
  Input,
  OnDestroy,
  numberAttribute,
  viewChild,
  Signal
} from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { Subject } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../../services/media-query.service';
import { StickyObserverComponent } from '../observer/sticky-observer.component';
import { StickyService } from '../sticky.service';

@Component({
  selector: 'td-wb-sticky-panel-top',
  templateUrl: 'sticky-panel-top.component.html',
  styleUrls: ['sticky-panel-top.component.scss'],
  imports: [
    StickyObserverComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StickyPanelTopComponent implements AfterViewInit, OnDestroy {
  private static readonly DEFAULT_MARGIN: number = 5;

  /* eslint-disable lines-between-class-members */
  @Input()
  get offset(): number { return this._offset; }
  set offset(value: number) {
    this._offset = numberAttribute(value, 0);
  }
  /* eslint-enable lines-between-class-members */

  @HostBinding('style.top.px')
  get top(): number {
    return this.pageOffset + this.offset - StickyPanelTopComponent.DEFAULT_MARGIN;
  }

  @HostBinding('class.td-wb-sticky-panel--stuck')
  get isStuck(): boolean {
    return this.stickyEnabled && this._stuck;
  }

  @HostBinding('attr.aria-hidden')
  get isAriaHidden(): boolean {
    return this.stickyEnabled && this._stuck;
  }

  readonly stickyObserverComponent: Signal<StickyObserverComponent | undefined> = viewChild(StickyObserverComponent);

  private _stuck: boolean = false;
  private _offset: number = 0;
  private stickyEnabled: boolean = false;
  private readonly destroy: Subject<void> = new Subject<void>();

  private readonly pageOffset: number;

  constructor(private changeDetectorRef: ChangeDetectorRef,
              private mediaQueryService: MediaQueryService,
              stickyService: StickyService) {
    this.pageOffset = stickyService.getPageOffset();
    this.mediaQueryService.observe(Breakpoint.LT_MD)
      .pipe(takeUntil(this.destroy))
      .subscribe((breakPointState: BreakpointState): void => {
        this.stickyEnabled = breakPointState.matches;
        this.changeDetectorRef.markForCheck();
      });
  }

  ngAfterViewInit(): void {
    this.stickyObserverComponent().stateChange
      .pipe(takeUntil(this.destroy))
      .subscribe((stuck: boolean): void => {
        this._stuck = stuck;
        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
